// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ysfmbdsizscwiikwxanx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlzZm1iZHNpenNjd2lpa3d4YW54Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4MTcxMDksImV4cCI6MjA3MTM5MzEwOX0.VgkJKUyLL3NM1YWhT_JJmzu4cWPlhyGzuk9TsX3Ltbw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});